import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';

import { Token } from '../../data/models/base';
import { TokenService } from '../services/base';

@Injectable()
export class AuthHttp {

    constructor(private http: Http) { }

    createAuthorizationHeader() {
        let token: Token = TokenService.getToken();

        let headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');

        if (token) {
            headers.append('Token-Id', token.TokenId);
            headers.append('Token', JSON.stringify(token));
        }
        // alert(JSON.stringify(headers));
        return headers;
    }

    get(url: string, options?: RequestOptionsArgs) {
        if (!options) {
            options = new RequestOptions();
        }

        options.headers = this.createAuthorizationHeader();
        return this.http.get(url, options);
    }

    post(url: string, body: any, options?: RequestOptionsArgs) {
        if (!options) {
            options = new RequestOptions();
        }

        options.headers = this.createAuthorizationHeader();
        return this.http.post(url, body, options);
    }

    put(url: string, body: any, options?: RequestOptionsArgs) {
        if (!options) {
            options = new RequestOptions();
        }

        options.headers = this.createAuthorizationHeader();
        return this.http.put(url, body, options);
    }

    delete(url: string, options?: RequestOptionsArgs) {
        if (!options) {
            options = new RequestOptions();
        }

        options.headers = this.createAuthorizationHeader();
        return this.http.delete(url, options);
    }

    getNoAuth(url: string, options?: RequestOptionsArgs) {
        if (!options) {
            options = new RequestOptions();
        }
                
        return this.http.get(url, options);
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/common/auth-http.ts